import React from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes'
import {connect} from 'react-redux';
import sliderBackground from '../../../resource/ui/videojuegosPizarra.png';
class GameContainer extends React.Component {

    render() {

        const {options,isMobile,isTablet,dictionary} = this.props
        let params = {};


        return (
            <div className="ChaptersModalContainer GameModalContainer">
                <div className="sliderContainer" style={{ backgroundImage:"url("+sliderBackground+")", backgroundRepeat:'no-repeat', backgroundSize:"100% 100%"}}>
                    <iframe title="UgoySerena game" src="/game/index.html"
                            frameBorder="0"
                            allow="autoplay; fullscreen; gamepad"
                            allowFullScreen></iframe>
                </div>
            </div>

        )
    }

}

GameContainer.propTypes = {

    options: PropTypes.object.isRequired,
    dictionary: PropTypes.object.isRequired,
}
const mapStateToProps = (state, ownProps) => {
    return {
        options:state.options,
        dictionary: state.dictionary,
    }
}

const mapSizesToProps = ({width}) => ({
    isMobile: width < 480,
    isTablet: width < 1024,
})

export default connect(mapStateToProps)(withSizes(mapSizesToProps)(GameContainer));





// WEBPACK FOOTER //
// ./src/components/pages/parts/GameContainer.js